import React, { useState, useEffect } from "react";
import "./Announcements.css";
import { useNavigate } from "react-router-dom";
import apiClient from "../utils/apiClient"; // global API client with token + expiry handling
import SessionHandler from "../components/SessionHandler"; // global session expiry modal

const Announcement = () => {
  const [announcements, setAnnouncements] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const data = await apiClient("/announcements/");
        if (!data) return; // apiClient handles 401

        if (Array.isArray(data)) {
          setAnnouncements(data);
        } else if (Array.isArray(data.results)) {
          setAnnouncements(data.results);
        } else {
          setAnnouncements([]);
        }
      } catch (error) {
        console.error("Error fetching announcements:", error);
      }
    };

    fetchAnnouncements();
  }, []);

  const handleView = (announcement) => {
    navigate(`/dashboard/announcements/view/${announcement.id}`, {
      state: {
        title: announcement.title,
        date: new Date(announcement.valid_upto).toLocaleDateString(),
        details: announcement.message,
      },
    });
  };

  return (
    <div className="announcement-page">
      <h1 className="page-title">Announcements</h1>

      <div className="table-wrapper">
        <table className="announcement-table">
          <thead>
            <tr>
              <th>Sr.no</th>
              <th>Title</th>
              <th>Date</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {announcements.length > 0 ? (
              announcements.map((announcement, index) => (
                <tr key={announcement.id}>
                  <td data-label="Sr.no">{index + 1}</td>
                  <td data-label="Title">{announcement.title}</td>
                  <td data-label="Date">
                    {new Date(
                      announcement.valid_upto
                    ).toLocaleDateString()}
                  </td>
                  <td data-label="Action">
                    <button
                      className="view-btn"
                      onClick={() => handleView(announcement)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="no-data">
                  No announcements found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Global session expiry modal */}
      <SessionHandler />
    </div>
  );
};

export default Announcement;
